(() => {
  'use strict';
  const data = document.querySelector('[data-review-offers]');
  if (!data) return;
  const offers = JSON.parse(data.textContent);
  const setups = ['controller', 'bundle', 'pedestal'];
  const catalogNode = document.querySelector('[data-pinball-catalog]');
  const catalog = catalogNode ? JSON.parse(catalogNode.textContent) : {};
  const productVariants = catalog.variants || [];
  const copy = catalog.checkoutCopy || {};
  let variants = productVariants;
  if (!variants.length) {
    const region = catalog.previewPrices?.[catalog.country] ? catalog.country : catalog.currency === 'EUR' ? 'DE' : 'US';
    variants = catalog.previewPrices?.[region] || [];
  }
  const currency = variants[0]?.currency || 'USD';
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency, currencyDisplay:'symbol', minimumFractionDigits:Number.isInteger(Number(value)) ? 0 : undefined}).format(Number(value));
  offers.forEach(offer => {
    const variant = variants.find(v => v.setup === offer.setup);
    if (!variant) return;
    Object.assign(offer, {variantId:variant.id,sku:variant.sku,amount:variant.amount,price:money(variant.amount),compare:money(variant.compareAmount),onSale:variant.compareAmount > variant.amount,available:variant.available});
    offer.savings = offer.onSale ? [copy.save_prefix || 'Save', money(variant.compareAmount - variant.amount), copy.save_suffix || 'on pre-order'].join(' ') : '';
  });
  document.querySelectorAll('[data-pinball-currency]').forEach(node => node.textContent = currency);
  // Apply Shopify prices to the existing setup cards on landing and product pages.
  offers.forEach(offer => {
    const card = document.querySelector('input[name="setup"][value="' + offer.setup + '"]')?.closest('label');
    if (card) {
      const p = card.querySelector('.rc-setup-price b'), c = card.querySelector('.rc-setup-price s');
      if (p) p.textContent = offer.price;
      if (c) { c.textContent = offer.compare; c.hidden = !offer.onSale; }
    }
    const link = document.querySelector('article [data-review-setup="' + offer.setup + '"]');
    const tile = link?.closest('article');
    if (tile) {
      const p = tile.querySelector('[data-offer-price], .zx-offer__accessory-price'), c = tile.querySelector('[data-offer-compare]');
      if (p) p.textContent = offer.price;
      if (c) { c.textContent = offer.compare; c.hidden = !offer.onSale; }
      const savings = tile.querySelector('[data-offer-saving]');
      if (savings) { savings.textContent = offer.savings; savings.hidden = !offer.onSale; }
    }
  });
  const find = setup => offers.find(offer => offer.setup === setup);
  // Only current Shopify variants can be ordered; preview prices are display-only.
  const canOrder = setup => productVariants.some(variant => variant.setup === setup && variant.id && variant.available === true && String(variant.id) === String(find(setup)?.variantId));
  const text = (scope, selector, value) => {
    const node = scope.querySelector(selector);
    if (node) node.textContent = value;
  };
  const read = () => {
    const params = new URL(location.href).searchParams;
    const legacy = {'52907314413850': 'bundle', '52913870864666': 'controller', '52913870897434': 'pedestal', '53219249291546': 'pedestal'};
    return setups.includes(params.get('setup')) ? params.get('setup') : legacy[params.get('variant')] || 'controller';
  };
  const write = setup => {
    const url = new URL(location.href);
    url.searchParams.delete('game');
    const selected = find(setup);
    if (selected?.variantId) url.searchParams.set('variant', selected.variantId);
    if (setup) url.searchParams.set('setup', setup);
    try { history.replaceState(history.state, '', url); } catch (_) { /* Direct-file selection still works. */ }
  };
  // Older links may carry a game choice. Only the hardware setup survives.
  const params = new URL(location.href).searchParams;
  if (params.has('game') || params.has('variant')) write(document.querySelector('[data-review-configurator]') ? read() : null);

  document.querySelectorAll('[data-review-setup]').forEach(link => {
    const setup = link.dataset.reviewSetup;
    if (setups.includes(setup)) {
      const target = new URL(window.PinballFXV15.productUrl, location.origin);
      target.searchParams.set('setup', setup);
      const offer = find(setup); if (offer?.variantId) target.searchParams.set('variant', offer.variantId);
      target.hash = 'zx-buybox'; link.href = target.href;
    }
  });

  const form = document.querySelector('[data-review-configurator]');
  if (!form) return;
  const root = document.querySelector('[data-pinball-native]');
  const shippingSchedule = {controller:copy.shipping_controller, bundle:copy.shipping_bundle, pedestal:copy.shipping_pedestal};
  const scheduleProperty = document.createElement('input');
  scheduleProperty.type = 'hidden';
  scheduleProperty.name = 'properties[' + copy.shipping_property + ']';
  form.appendChild(scheduleProperty);
  let setup = read();
  const error = message => {
    const node = form.querySelector('[data-selection-error]');
    node.textContent = message;
    node.hidden = !message;
  };
  const render = () => {
    const offer = find(setup);
    const stand = setup === 'pedestal';
    scheduleProperty.value = shippingSchedule[setup];
    text(root, '.zx-eta b', shippingSchedule[setup]);
    form.querySelectorAll('input[name=setup]').forEach(input => { input.checked = input.value === setup; });
    text(root, '[data-pinball-price]', offer.price);
    text(root, '[data-pinball-compare]', offer.compare);
    text(root, '[data-pinball-savings]', offer.savings);
    text(root, '[data-pinball-variant-title]', offer.title);
    text(root, '[data-pinball-sku]', offer.sku || '');
    const id = form.querySelector('[data-pinball-variant-id]'); if (id) id.value = offer.variantId || '';
    const region = catalog.country || 'US';
    const shipping = region === 'US' ? {controller:'US$33',bundle:'US$77',pedestal:'US$44'} : region === 'GB' ? {controller:'£30',bundle:'£50',pedestal:'£30'} : null;
    text(root, '[data-pinball-shipping-note]', shipping ? '+ ' + shipping[setup] + ' standard ' + (region === 'GB' ? 'UK' : 'contiguous US') + ' shipping. See shipping details below.' : 'Shipping calculated at checkout for your address. See shipping details below.');
    root.querySelector('[data-pinball-compare]').hidden = !offer.onSale;
    root.querySelector('[data-pinball-savings]').hidden = !offer.onSale;
    const activation = root.querySelector('[data-activation-flow]');
    if (activation) activation.hidden = stand;
    const entitlement = root.querySelector('[data-review-entitlement]');
    if (entitlement) entitlement.hidden = !stand;
    text(root, '[data-entitlement-title]', stand ? 'Pedestal Only' : 'Manual code included');
    text(root, '[data-entitlement-copy]', offer.configurationNote);
    const orderButton = form.querySelector('[data-review-order]');
    const available = canOrder(setup);
    orderButton.disabled = !catalog.orderingEnabled || !available;
    orderButton.textContent = available
      ? (stand ? copy.pedestal_label : copy.preorder_label)
      : copy.unavailable_label;
    form.dataset.selectedOffer = offer.id;
    error('');
  };
  form.addEventListener('change', event => {
    if (event.target.name !== 'setup' || !setups.includes(event.target.value)) return;
    setup = event.target.value;
    render();
    write(setup);
  });
  form.addEventListener('submit', event => {
    const input = form.querySelector('input[name=quantity]');
    const quantity = Number(input.value);
    if (!Number.isSafeInteger(quantity) || quantity < 1) {
      event.preventDefault();
      error(copy.quantity_error);
      input.focus();
      return;
    }
    const offer = find(setup);
    if (!catalog.orderingEnabled || !canOrder(setup)) {
      event.preventDefault();
      error(copy.availability_error);
      return;
    }
    // Submit the selected Shopify variant and quantity through the native cart.
    form.querySelector('[data-pinball-variant-id]').value = offer.variantId;
    error('');
  });
  addEventListener('popstate', () => { setup = read(); render(); if (new URL(location.href).searchParams.has('game')) write(setup); });
  render();
})();


